import { LineChart, Line, XAxis, YAxis, ReferenceLine, ResponsiveContainer, LabelList, Tooltip } from "recharts";

const TipBox = ({ active, payload, target }) => {
  if (!active || !payload?.length) return null;
  const p = payload[0].payload;
  if (p.value == null) return null;
  return (
    <div className="px-2 py-1 rounded bg-gray-900 text-white text-[13px] font-bold shadow-lg">
      {p.label}: {p.value}{target ? ` · ${Math.round((p.value / target) * 100)}% obj` : ""}
      {p.delta != null && <span style={{ color: p.delta >= 0 ? "#6ee7b7" : "#fca5a5" }}> ({p.delta >= 0 ? "+" : ""}{p.delta})</span>}
    </div>
  );
};

const Dot = ({ cx, cy, index, cw, color }) => {
  if (cx == null || cy == null) return null;
  const current = index === cw - 1;
  return <circle cx={cx} cy={cy} r={current ? 4.5 : 3} fill={current ? color : "#fff"}
                 stroke={color} strokeWidth={2}/>;
};

export const ProjectionWeekTrend = ({ weekly, currentWeek, target, color, targetColor = "#94a3b8" }) => {
  const cw = currentWeek || 5;
  const data = (weekly || []).map((v, i) => ({
    label: `W${i + 1}`,
    value: i < cw ? v : null,
    delta: i > 0 && i < cw ? v - weekly[i - 1] : null,
  }));
  const vals = data.map((d) => d.value).filter((v) => v != null);
  const lo = Math.min(...vals), hi = Math.max(...vals);
  const pad = Math.max((hi - lo) * 0.35, hi * 0.06, 2);
  const domain = [Math.max(0, Math.floor(lo - pad)), Math.ceil(hi + pad)];
  const showTarget = target > 0 && target <= domain[1] * 1.15;
  if (showTarget) domain[1] = Math.max(domain[1], Math.ceil(target * 1.03));
  return (
    <div className="mt-2" data-testid="projection-week-trend">
      <div className="text-[12px] font-extrabold uppercase tracking-wider text-gray-400 mb-0.5">
        Evolución semanal
      </div>
      <div style={{ height: 120 }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 16, right: 14, left: 14, bottom: 0 }}>
            <YAxis hide domain={domain}/>
            <XAxis dataKey="label" tickLine={false} axisLine={false} interval={0}
                   tick={{ fontSize: 12, fontWeight: 700, fill: "#9ca3af" }}/>
            {showTarget && <ReferenceLine y={target} stroke={targetColor} strokeDasharray="3 3"/>}
            <Tooltip content={<TipBox target={target}/>} cursor={{ stroke: "#e5e7eb" }}/>
            <Line type="monotone" dataKey="value" stroke={color} strokeWidth={2.5}
                  connectNulls={false} isAnimationActive animationDuration={500}
                  dot={(p) => <Dot key={p.index} {...p} cw={cw} color={color}/>}
                  activeDot={{ r: 5 }}>
              <LabelList dataKey="value" position="top"
                         style={{ fontSize: 12, fontWeight: 800, fill: "#374151" }}/>
            </Line>
          </LineChart>
        </ResponsiveContainer>
      </div>
      <div className="flex justify-end text-[11px] font-bold text-gray-400 -mt-0.5">
        <span style={{ color: targetColor }}>
          {showTarget && <span>- - - </span>}
          Objetivo {target}{!showTarget && target > 0 && hi < target ? ` · faltan ${target - (data[cw - 1]?.value ?? hi)}` : ""}
        </span>
      </div>
    </div>
  );
};
